export default {
  title: 'Dados adicionais associados à fatura',
  name: 'Nome',
  value: 'Valor'
}